import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Thesis from "../components/Thesis";
import Metrics from "../components/Metrics";
import Receipts from "../components/Receipts";
import Hobbies from "../components/Hobbies";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingBadge from "../components/FloatingBadge";
import ScrollProgress from "../components/ScrollProgress";
import { RoleProvider } from "../context/RoleContext";
import { resolveRole } from "../roles";

const Portfolio = () => {
  const [params] = useSearchParams();
  const role = resolveRole(params.get("role"));

  useEffect(() => {
    document.title = role.meta.title;
    document.querySelectorAll('meta[name="description"]').forEach((m) => m.setAttribute("content", role.meta.description));
  }, [role]);

  return (
    <RoleProvider role={role}>
      <div data-testid={`portfolio-${role.key}`} className="min-h-screen bg-[#121826] text-[#EDEDED] relative overflow-x-hidden">
        <Navbar />
        <ScrollProgress />
        <main>
          <Hero />
          <Marquee />
          <Thesis />
          <Metrics />
          <Receipts />
          <Contact />
          <div className="palette-rail h-1 w-full" aria-hidden />
          <Hobbies />
        </main>
        <Footer />
        <FloatingBadge />
      </div>
    </RoleProvider>
  );
};

export default Portfolio;
